"use strict";
/*
 * Copyright 2026, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSegmentsByServiceAndPeriod = exports.buildPeriodSegmentData = void 0;
const getBaseSegmentsFromPath = (path) => path.attributes.data.segments || [];
// === Pure helpers ===
/** Build a PeriodSegmentData object from segments, dwell times, and total distance.
 *  Computes travel/operating totals and speed metrics. */
const buildPeriodSegmentData = (segments, dwellTimeSeconds, totalDistanceMeters) => {
    const travelTotal = segments.reduce((sum, s) => sum + s.travelTimeSeconds, 0);
    const dwellTotal = dwellTimeSeconds.reduce((sum, d) => sum + d, 0);
    const operatingTotal = travelTotal + dwellTotal;
    return {
        segments,
        dwellTimeSeconds,
        travelTimeWithoutDwellTimesSeconds: travelTotal,
        operatingTimeWithoutLayoverTimeSeconds: operatingTotal,
        averageSpeedWithoutDwellTimesMetersPerSecond: travelTotal > 0 ? Math.round((totalDistanceMeters / travelTotal) * 100) / 100 : 0,
        operatingSpeedMetersPerSecond: operatingTotal > 0 ? Math.round((totalDistanceMeters / operatingTotal) * 100) / 100 : 0
    };
};
exports.buildPeriodSegmentData = buildPeriodSegmentData;
/**
 * Serialize the flat LocalSegmentTimes structure (one entry per service) to the nested
 * PeriodSegmentData shape that path.data.segmentsByServiceAndPeriod expects. Uses
 * buildPeriodSegmentData to compute totals and speeds per period.
 */
const buildSegmentsByServiceAndPeriod = (params) => {
    const expandedData = params.expandedData;
    const path = params.path;
    const dwellTimes = params.dwellTimes;
    const baseSegments = getBaseSegmentsFromPath(path);
    const totalDistanceMeters = baseSegments.reduce((sum, s) => { var _a; return sum + ((_a = s.distanceMeters) !== null && _a !== void 0 ? _a : 0); }, 0);
    const result = {};
    for (const [serviceId, periodEntries] of Object.entries(expandedData)) {
        for (const [periodShortname, times] of Object.entries(periodEntries)) {
            if (!times || times.length === 0)
                continue;
            if (!result[serviceId])
                result[serviceId] = {};
            const segmentsForPeriod = times.map((t, i) => {
                var _a, _b;
                return ({
                    travelTimeSeconds: t,
                    distanceMeters: (_b = (_a = baseSegments[i]) === null || _a === void 0 ? void 0 : _a.distanceMeters) !== null && _b !== void 0 ? _b : null
                });
            });
            result[serviceId][periodShortname] = (0, exports.buildPeriodSegmentData)(segmentsForPeriod, dwellTimes, totalDistanceMeters);
        }
    }
    return result;
};
exports.buildSegmentsByServiceAndPeriod = buildSegmentsByServiceAndPeriod;
//# sourceMappingURL=PathSegmentTimeUtils.js.map